import React from "react";
import { Button } from "./ui/button";
import { useParams, useNavigate } from "react-router";
import Modal from "../Modal";
import useFirebaseKiln from "../hooks/useFirebaseKiln";
import useFirebaseProjects from "../hooks/useFirebaseProjects";
import useKilnActions from "../hooks/useKilnActions";
import _ from "lodash";

const KilnDeletePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const kiln = useFirebaseKiln(id!);
  const allProjects = useFirebaseProjects();
  const { deleteKiln } = useKilnActions();

  const projects = allProjects
    ? _.filter(allProjects, (project) => project.kiln === id)
    : [];

  const actions = () => (
    <React.Fragment>
      <Button
        variant="destructive"
        disabled={projects.length !== 0}
        onClick={() => {
          if (projects.length === 0) {
            deleteKiln(id!);
          }
        }}
      >
        Delete
      </Button>
      <Button variant="outline" onClick={() => navigate(-1)}>Cancel</Button>
    </React.Fragment>
  );

  const renderContent = () => {
    if (!kiln || !allProjects) {
      return <div>Loading...</div>;
    }
    if (projects.length !== 0) {
      return (
        <div>
          There are projects that still refer to this Kiln. You can't delete the Kiln without first
          deleting or editing any projects that refer to it.
        </div>
      );
    }

    return (
      <React.Fragment>
        <div>Name:{kiln.name}</div>
      </React.Fragment>
    );
  };

  return (
    <Modal
      title="Delete Kiln"
      content={renderContent()}
      actions={actions()}
      onDismiss={() => navigate(-1)}
    />
  );
};

export default KilnDeletePage;
